import { featureCards, type FeatureCard } from "@/mocks/gossipData";

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
              <i className="ri-article-fill text-primary-600"></i>
              深度 · 吃瓜精选爆款话题
            </span>
            <h2 className="mt-2 font-display text-3xl md:text-4xl text-foreground-950">
              不只是吃瓜<span className="text-primary-600">·</span>更读懂背后
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
              除了快速看热度，我们也把高讨论度的话题掰开揉碎，给你值得静下来读一遍的深度盘点。
            </p>
          </div>
          <a href="#today" className="whitespace-nowrap inline-flex items-center gap-1.5 h-10 px-5 rounded-full bg-secondary-100 text-secondary-900 text-sm font-semibold hover:bg-secondary-200 transition-colors self-start md:self-auto">
            回顶部榜单
            <i className="ri-arrow-up-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureCards.map((card: FeatureCard) => (
            <article
              key={card.id}
              className="group overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200 hover:ring-primary-300 hover:shadow-soft transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={card.image}
                  alt={card.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-950/70 backdrop-blur px-2.5 py-1 text-xs font-semibold text-background-50">
                  {card.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 text-primary-700 px-2.5 py-0.5 text-[11px] font-semibold">
                  <i className="ri-fire-line text-xs"></i>
                  {card.tag}
                </span>
                <h3 className="mt-2.5 text-[15px] font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{card.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <div className="flex items-center gap-3">
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{card.views}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line"></i>{card.comments}</span>
                  </div>
                  <span className="inline-flex items-center gap-1">{card.time}<i className="ri-arrow-right-up-line opacity-0 group-hover:opacity-100 transition text-primary-500"></i></span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}